export const removeHyphensAndPoints = (value = "") => {
	return value.replace(/[-.]*/g, "")
}
